import { createContext, useContext, useState, useMemo } from "react";

const FileContext = createContext();

export function FileProvider({ children }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [interactionModel, setInteractionModel] = useState(null);
  const [executedFile, setExecutedFile] = useState([]);
  const [results, setResults] = useState([]);
  const [notify, setNotify] = useState(false);
  const [open, setOpen] = useState(true);

  const value = useMemo(
    () => ({
      selectedFile,
      setSelectedFile,
      files,
      setFiles,
      selectedId,
      setSelectedId,
      interactionModel,
      setInteractionModel,
      executedFile,
      setExecutedFile,
      results,
      setResults,
      notify,
      setNotify,
      open,
      setOpen,
    }),
    [
      selectedFile,
      files,
      selectedId,
      interactionModel,
      executedFile,
      results,
      notify,
      open,
    ],
  );

  return <FileContext.Provider value={value}>{children}</FileContext.Provider>;
}

export const useFile = () => useContext(FileContext);
